import Component from 'flarum/common/Component';
import Select from 'flarum/common/components/Select';
import app from 'flarum/forum/app';

import { activeAlts } from '../altsStore';

/**
 * The "posting as" control in the composer header.
 *
 * Identity is chosen per post rather than per session on purpose: a
 * session-wide switch makes it far too easy to forget which face you are
 * wearing and post in character somewhere you meant not to.
 */
export default class IdentityPicker extends Component {
  view() {
    const composer = this.attrs.composer;
    const alts = activeAlts();

    if (!alts.length) return null;

    const options = { '': app.translator.trans('nurriemunchers-alts.forum.composer.yourself') };

    alts.forEach((alt) => {
      options[alt.id()] = alt.displayName();
    });

    return (
      <div className="NurrieAlts-identity">
        <label>{app.translator.trans('nurriemunchers-alts.forum.composer.posting_as')}</label>
        <Select
          options={options}
          value={composer.altId || ''}
          onchange={(value) => {
            composer.altId = value || null;
          }}
        />
      </div>
    );
  }
}
